import types from "./types";

const clearUpgradeData = () => ({
    type: types.CLEAR_COMM_UPGRADE_DATA,
});

const toggleUpgradesLoading = (isLoading) => ({
    type: types.TOGGLE_COMM_UPGRADES_LOADING,
    isLoading,
});

const setUpgradesError = (error) => ({
    type: types.SET_COMM_UPGRADES_ERROR,
    error,
});

const setCommBaseModelId = (baseModelId) => ({
    type: types.SET_COMM_BASE_MODEL_ID,
    payload: { baseModelId },
});

const adjustCommPackageCost = ({ modelId = "", packageId = "", amount = 0 }) => ({
    type: types.ADJUST_COMM_PACKAGE_COST,
    payload: { modelId, packageId, amount },
});

const initCapitalCosts = ({ capitalCosts }) => ({
    type: types.INIT_ALL_CAPITAL_COSTS,
    payload: { capitalCosts },
});

const removeCommModelPackageCosts = (modelId) => ({
    type: types.REMOVE_COMM_MODEL_PACKAGE_COSTS,
    payload: { modelId },
});

const addCommModelPackageCost = ({ upgrades, components, modelId, packageId }) => ({
    type: types.CALC_COMM_MODEL_PACKAGE_COST,
    payload: { upgrades, components, modelId, packageId },
});

const addCommUpgradePackage = ({ packageId = "", packageUpdates = {} }) => ({
    type: types.ADD_COMM_UPGRADE_PACKAGE,
    packageId,
    packageUpdates,
});

const updateCommUpgradePackage = ({ packageId = "", packageUpdates = {} }) => ({
    type: types.UPDATE_COMM_UPGRADE_PACKAGE,
    packageId,
    packageUpdates,
});

const deleteCommUpgradePackage = ({ packageId = "" }) => ({
    type: types.DELETE_COMM_UPGRADE_PACKAGE,
    packageId,
});

const setUpgradePackages = ({ packages = {} }) => ({
    type: types.SET_COMM_UPGRADE_PACKAGES,
    packages,
});

const setInitUpgradePackages = ({ packages = {} }) => ({
    type: types.SET_INIT_COMM_UPGRADE_PACKAGES,
    packages,
});

const updateCommPackageUpgrades = ({ packageId, upgrades = {}, dateTime }) => ({
    type: types.UPDATE_COMM_PACKAGE_UPGRADES,
    packageId,
    upgrades,
    dateTime,
});

const deleteCommPackageUpgrade = ({ packageId, upgradeId }) => ({
    type: types.DELETE_COMM_PACKAGE_UPGRADE,
    packageId,
    upgradeId,
});

const saveUpgradesStart = () => ({
    type: types.SAVE_COMM_UPGRADES_START,
});

const saveUpgradesSuccess = () => ({
    type: types.SAVE_COMM_UPGRADES_SUCCESS,
});

const reorderUpgradePackages = (packages = []) => ({
    type: types.UPDATE_COMM_UPGRADE_PACKAGE_ORDER,
    packages,
});

const updateCommUpgradeCost = ({ packageId, upgradeId, upgradeType, total, communityTotals, items, communityItems }) => ({
    type: types.UPDATE_COMM_UPGRADE_COST,
    packageId,
    upgradeId,
    upgradeType,
    total,
    communityTotals,
    items,
    communityItems,
});

const updatePackageOperatingConditions = ({ packageId, operatingConditions }) => ({
    type: types.UPDATE_COMM_PACKAGE_OPERATING_CONDITIONS,
    packageId,
    operatingConditions,
});

const updatePackageBaseCase = ({ packageId, relativeBaseCase }) => ({
    type: types.UPDATE_COMM_PACKAGE_BASE_CASE,
    packageId,
    relativeBaseCase,
});

const updateUpgradeSnapshot = (upgrades) => ({
    type: types.UPDATE_COMM_UPGRADE_SNAPSHOT_SUCCESS,
    upgrades,
});

export default {
    clearUpgradeData,
    toggleUpgradesLoading,
    setUpgradesError,
    setCommBaseModelId,
    adjustCommPackageCost,
    addCommUpgradePackage,
    updateCommUpgradePackage,
    setInitUpgradePackages,
    setUpgradePackages,
    deleteCommUpgradePackage,
    updateCommPackageUpgrades,
    deleteCommPackageUpgrade,
    reorderUpgradePackages,
    updateCommUpgradeCost,
    updatePackageOperatingConditions,
    updatePackageBaseCase,
    updateUpgradeSnapshot,
    initCapitalCosts,
    removeCommModelPackageCosts,
    addCommModelPackageCost,
    saveUpgradesStart,
    saveUpgradesSuccess,
};
